const admin = JSON.parse(localStorage.getItem("admin"));
export default admin;
